import { ArrowDown, ArrowUp, Eye, Plus, Trash2 } from "lucide-react";

export const newVideo = () => ({ id: null, titre: "", url: "", provider: "vimeo", expire_le: "" });

const inputCls = "w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-cfhtb-light focus:border-cfhtb-secondary";
const labelCls = "block text-xs font-medium text-cfhtb-heading mb-1";
const iconBtn = "p-1.5 rounded-md border border-slate-200 text-cfhtb-text hover:bg-cfhtb-bg disabled:opacity-30 transition-colors";

export const ReplayVideosEditor = ({ videos, onChange, stats = {} }) => {
  const update = (i, k, v) => onChange(videos.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const move = (i, d) => {
    const next = [...videos];
    [next[i], next[i + d]] = [next[i + d], next[i]];
    onChange(next);
  };
  const remove = (i) => onChange(videos.filter((_, j) => j !== i));
  const moveTo = (i, pos) => {
    const to = Math.min(Math.max(parseInt(pos, 10) || 1, 1), videos.length) - 1;
    if (to === i) return;
    const next = [...videos];
    const [item] = next.splice(i, 1);
    next.splice(to, 0, item);
    onChange(next);
  };

  return (
    <div className="space-y-3" data-testid="replay-videos-editor">
      {videos.map((v, i) => (
        <div key={i} data-testid={`replay-video-row-${i}`} className="rounded-md border border-slate-200 bg-slate-50/60 p-3 space-y-3">
          <div className="flex items-center gap-2">
            <select data-testid={`replay-video-ordre-${i}`} value={i + 1} onChange={(e) => moveTo(i, e.target.value)}
              title="Ordre d'affichage" aria-label="Ordre d'affichage"
              className="w-16 shrink-0 rounded-md border border-slate-300 px-2 py-2 text-sm font-semibold text-cfhtb-secondary">
              {videos.map((_, j) => <option key={j} value={j + 1}>{j + 1}</option>)}
            </select>
            <input data-testid={`replay-video-titre-${i}`} className={inputCls} value={v.titre}
              onChange={(e) => update(i, "titre", e.target.value)} placeholder={`Titre (ex. Matinée) — Vidéo ${i + 1}`} />
            <button type="button" data-testid={`replay-video-up-${i}`} className={iconBtn} disabled={i === 0} onClick={() => move(i, -1)} aria-label="Monter"><ArrowUp className="h-4 w-4" /></button>
            <button type="button" data-testid={`replay-video-down-${i}`} className={iconBtn} disabled={i === videos.length - 1} onClick={() => move(i, 1)} aria-label="Descendre"><ArrowDown className="h-4 w-4" /></button>
            <button type="button" data-testid={`replay-video-delete-${i}`} className={`${iconBtn} hover:text-cfhtb-error`} onClick={() => remove(i)} aria-label="Supprimer"><Trash2 className="h-4 w-4" /></button>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-7 gap-3 sm:pl-[4.5rem]">
            <div className="sm:col-span-3">
              <label className={labelCls}>URL de la vidéo</label>
              <input data-testid={`replay-video-url-${i}`} className={inputCls} value={v.url} onChange={(e) => update(i, "url", e.target.value)} placeholder="https://vimeo.com/…" />
            </div>
            <div className="sm:col-span-2">
              <label className={labelCls}>Plateforme</label>
              <select data-testid={`replay-video-provider-${i}`} className={inputCls} value={v.provider} onChange={(e) => update(i, "provider", e.target.value)}>
                <option value="vimeo">Vimeo</option>
                <option value="youtube">YouTube</option>
                <option value="pcloud">pCloud</option>
              </select>
            </div>
            <div className="sm:col-span-2">
              <label className={labelCls}>Expiration (vide = illimité)</label>
              <input data-testid={`replay-video-expiration-${i}`} type="datetime-local" className={inputCls} value={v.expire_le} onChange={(e) => update(i, "expire_le", e.target.value)} />
            </div>
          </div>
          {v.id && (
            <p data-testid={`replay-video-stats-${i}`} className="sm:pl-[4.5rem] flex items-center gap-1.5 text-xs text-cfhtb-text">
              <Eye className="h-3.5 w-3.5 text-cfhtb-light" />
              {stats[v.id]
                ? `${stats[v.id].personnes} inscrit${stats[v.id].personnes > 1 ? "s l'ont" : " l'a"} lancée · ${stats[v.id].lectures} lecture${stats[v.id].lectures > 1 ? "s" : ""}`
                : "Pas encore visionnée"}
            </p>
          )}
        </div>
      ))}
      <button type="button" data-testid="replay-video-add-button" onClick={() => onChange([...videos, newVideo()])}
        className="inline-flex items-center gap-2 text-sm font-medium text-cfhtb-primary border border-dashed border-cfhtb-light rounded-md px-4 py-2 hover:bg-cfhtb-bg transition-colors">
        <Plus className="h-4 w-4" /> Ajouter une vidéo
      </button>
    </div>
  );
};
